




















































































































































































































































































































































import { defineComponent, reactive, SetupContext, toRef, toRefs, ref, watch, onMounted } from "@vue/composition-api";
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import { BModal } from 'bootstrap-vue';
import TeacherMainteTab from "../../components/TeacherMainteTab.vue"
import { User, UserResultViewableRange, SearchCondition } from "../../modules/teacher/TeacherList"

interface Data {
  users: User[]
  condition: SearchCondition
  userFields: any[]
  courseFields: any[]
  campusFields: any[]
  classificationFields: any[]
  subjectFields: any[]
  userResultViewableRangeFields: any[]
  errors: string[]
  isAllCheckedScoringAuth: boolean
  isAllCheckedResultOutputAuth: boolean
  isAllCheckedBaseSheetEditAuth: boolean
  isAllCheckedTouanUploadAuth: boolean
  isAllCheckedSubmittedAtEditAuth: boolean
  isAllCheckedIsActive: boolean
  isAllCheckedPassword: boolean
  isAllCheckedDelete: boolean
  isAllCheckedCourse: boolean
  isAllCheckedCampus: boolean
  isAllCheckedClassification: boolean
  isAllCheckedSubject: boolean
  modalUser: User
  scorableTabNo: number
  tabNo: number
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "teacher-mainte-tab": TeacherMainteTab,
  },
  setup(props, context: SetupContext) {

    const userNameModalRef = ref<InstanceType<typeof BModal>>();
    const roleModalRef = ref<InstanceType<typeof BModal>>();
    const scorableModalRef = ref<InstanceType<typeof BModal>>();
    const userResultViewableRangeModalRef = ref<InstanceType<typeof BModal>>();

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      users: [],
      condition: new SearchCondition(),
      userFields: [
        {key: "login_id", label: "Email", sortable: true, class: 'text-center b-table-th-td'},
        {key: "name", label: "氏名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "role", label: "権限", sortable: true, class: 'text-center b-table-th-td', thStyle: {width: "100px"}},
        {key: "scoring_auth", label: "採点権限", class: 'text-center b-table-th-td', thStyle: {width: "60px"}},
        {key: "result_output_auth", label: "成績出力権限", class: 'text-center b-table-th-td', thStyle: {width: "80px"}},
        {key: "base_sheet_edit_auth", label: "レポートマスタ編集権限", class: 'text-center b-table-th-td', thStyle: {width: "115px"}},
        {key: "touan_upload_auth", label: "一括アップロード権限", class: 'text-center b-table-th-td', thStyle: {width: "125px"}},
        {key: "submitted_at_edit_auth", label: "提出日時修正権限", class: 'text-center b-table-th-td', thStyle: {width: "80px"}},
        {key: "is_active", label: "有効/無効", class: 'text-center b-table-th-td', thStyle: {width: "60px"}},
        // {key: "scorable_range", label: "採点範囲", class: 'text-center b-table-th-td', thStyle: {width: "90px"}},
        // {key: "result_viewable_range", label: "成績閲覧範囲", class: 'text-center b-table-th-td', thStyle: {width: "90px"}},
        {key: "reset_password", label: "パスワード再設定", class: 'text-center b-table-th-td', thStyle: {width: "80px"}},
        {key: "delete", label: "削除", class: 'text-center b-table-th-td', thStyle: {width: "60px"}},
      ],
      courseFields: [
        {key: "course_code", label: "コースCD", sortable: true, class: 'text-center b-table-th-td'},
        {key: "name", label: "コース名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "check", label: "選択", class: 'text-center b-table-th-td', thStyle: {width: "100px"}},
      ],
      campusFields: [
        {key: "campus_code", label: "キャンパスCD", sortable: true, class: 'text-center b-table-th-td'},
        {key: "name", label: "キャンパス名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "check", label: "選択", class: 'text-center b-table-th-td', thStyle: {width: "100px"}},
      ],
      classificationFields: [
        {key: "class_code", label: "クラスCD", sortable: true, class: 'text-center b-table-th-td'},
        {key: "name", label: "クラス名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "check", label: "選択", class: 'text-center b-table-th-td', thStyle: {width: "100px"}},
      ],
      subjectFields: [
        {key: "subject_code", label: "科目CD", sortable: true, class: 'text-center b-table-th-td'},
        {key: "name", label: "科目名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "check", label: "選択", class: 'text-center b-table-th-td', thStyle: {width: "100px"}},
      ],
      userResultViewableRangeFields: [
        {key: "course_code", label: "コースCD", sortable: true, class: 'text-center b-table-th-td'},
        {key: "campus_code", label: "キャンパスCD", sortable: true, class: 'text-center b-table-th-td'},
        {key: "class_code", label: "クラスCD", sortable: true, class: 'text-center b-table-th-td'},
        {key: "delete", label: "削除", sortable: true, class: 'text-center b-table-th-td', thStyle: {width: "80px"}},
      ],
      errors: [],
      isAllCheckedScoringAuth: false,
      isAllCheckedResultOutputAuth: false,
      isAllCheckedBaseSheetEditAuth: false,
      isAllCheckedTouanUploadAuth: false,
      isAllCheckedSubmittedAtEditAuth: false,
      isAllCheckedIsActive: false,
      isAllCheckedPassword: false,
      isAllCheckedDelete: false,
      isAllCheckedCourse: false,
      isAllCheckedCampus: false,
      isAllCheckedClassification: false,
      isAllCheckedSubject: false,
      modalUser: null,
      scorableTabNo: 1,
      tabNo: 1,
    });

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.errors = [];
      await http.get(`/api/teacher/teacher_list?${Common.BuildQuery(state.condition, 'search_condition')}`).then(response => {
        state.users = response.data.users.map((x: any) => new User(x)); 
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 検索条件クリア
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondition();
    };

    /******************************
     * 採点権限更新
     ******************************/

    const updateScoringAuth = async () => {

      if (!confirm(`採点権限を保存します。よろしいですか？`)) {
        return;
      }

      context.root.$store.dispatch("showOverlay");
      state.errors = [];

      const flg_on_ids = state.users.filter(x => x.scoring_auth).map(x => x.id);
      const flg_off_ids = state.users.filter(x => !x.scoring_auth).map(x => x.id);

      await http.post(`/api/teacher/teacher_list/update_scoring_auth`, {flg_on_ids: flg_on_ids, flg_off_ids: flg_off_ids}).then(response => {
        alert(`処理が完了しました。`);
        search();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 成績出力権限更新
     ******************************/

    const updateResultOutputAuth = async () => {

      if (!confirm(`成績出力権限を保存します。よろしいですか？`)) {
        return;
      }

      context.root.$store.dispatch("showOverlay");
      state.errors = [];

      const flg_on_ids = state.users.filter(x => x.result_output_auth).map(x => x.id);
      const flg_off_ids = state.users.filter(x => !x.result_output_auth).map(x => x.id);

      await http.post(`/api/teacher/teacher_list/update_result_output_auth`, {flg_on_ids: flg_on_ids, flg_off_ids: flg_off_ids}).then(response => {
        alert(`処理が完了しました。`);
        search();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * レポートマスタ編集権限更新
     ******************************/

    const updateBaseSheetEditAuth = async () => {

      if (!confirm(`レポートマスタ編集権限を保存します。よろしいですか？`)) {
        return;
      }

      context.root.$store.dispatch("showOverlay");
      state.errors = [];

      const flg_on_ids = state.users.filter(x => x.base_sheet_edit_auth).map(x => x.id);
      const flg_off_ids = state.users.filter(x => !x.base_sheet_edit_auth).map(x => x.id);

      await http.post(`/api/teacher/teacher_list/update_base_sheet_edit_auth`, {flg_on_ids: flg_on_ids, flg_off_ids: flg_off_ids}).then(response => {
        alert(`処理が完了しました。`);
        search();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 一括アップロード権限更新
     ******************************/

    const updateTouanUploadAuth = async () => {

      if (!confirm(`一括アップロード権限を保存します。よろしいですか？`)) {
        return;
      }

      context.root.$store.dispatch("showOverlay");
      state.errors = [];

      const flg_on_ids = state.users.filter(x => x.touan_upload_auth).map(x => x.id);
      const flg_off_ids = state.users.filter(x => !x.touan_upload_auth).map(x => x.id);

      await http.post(`/api/teacher/teacher_list/update_touan_upload_auth`, {flg_on_ids: flg_on_ids, flg_off_ids: flg_off_ids}).then(response => {
        alert(`処理が完了しました。`);
        search();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 提出日時修正権限更新
     ******************************/

    const updateSubmittedAtEditAuth = async () => {

      if (!confirm(`提出日時修正権限を保存します。よろしいですか？`)) {
        return;
      }

      context.root.$store.dispatch("showOverlay");
      state.errors = [];

      const flg_on_ids = state.users.filter(x => x.submitted_at_edit_auth).map(x => x.id);
      const flg_off_ids = state.users.filter(x => !x.submitted_at_edit_auth).map(x => x.id);

      await http.post(`/api/teacher/teacher_list/update_submitted_at_edit_auth`, {flg_on_ids: flg_on_ids, flg_off_ids: flg_off_ids}).then(response => {
        alert(`処理が完了しました。`);
        search();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 有効状態更新
     ******************************/

    const updateIsActive = async () => {

      if (!confirm(`有効状態を保存します。よろしいですか？`)) {
        return;
      }

      context.root.$store.dispatch("showOverlay");
      state.errors = [];

      const flg_on_ids = state.users.filter(x => x.is_active).map(x => x.id);
      const flg_off_ids = state.users.filter(x => !x.is_active).map(x => x.id);

      await http.post(`/api/teacher/teacher_list/update_is_active`, {flg_on_ids: flg_on_ids, flg_off_ids: flg_off_ids}).then(response => {
        alert(`処理が完了しました。`);
        search();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * パスワードリセット
     ******************************/

    const resetPassword = async (): Promise<void> => {

      const ids = state.users.filter(x => x.is_password_checked).map(x => x.id);

      if(ids.length == 0){
        alert(`リセットする教師をチェックしてください。`);
        return;
      }

      if (!confirm(`選択している教師のパスワードをリセットします。新しいパスワードはメールで通知されます。よろしいですか？`)){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      await http.post(`/api/teacher/teacher_list/reset_password`, {ids: ids}).then(response => {
        alert(`処理が完了しました。`);
        search();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * アカウント削除
     ******************************/

    const deleteUser = async (): Promise<void> => {

      const ids = state.users.filter(x => x.is_delete_checked).map(x => x.id);

      if(ids.length == 0){
        alert(`削除する教師をチェックしてください。`);
        return;
      }

      if (!confirm(`選択している教師を削除します。よろしいですか？`)){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      await http.post(`/api/teacher/teacher_list/delete_user`, {ids: ids}).then(response => {
        alert(`処理が完了しました。`);
        search();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * モーダル表示
     ******************************/

    const showModal = (user: User, modalRef: BModal) => {
      state.modalUser = user;
      modalRef.show();
    }

    /******************************
     * 採点CD更新
     ******************************/

    const updateUserColumn = async (column_name: string, modalRef: BModal) => {

      let msg = "";
      if(column_name == "name"){
        msg = "氏名を保存します。よろしいですか？"
      }else if(column_name == "role"){
        msg = "アカウント権限を保存します。よろしいですか？"
      }else if(column_name == "scorable_codes"){
        msg = "採点範囲を保存します。よろしいですか？"
      }

      if (!confirm(msg)) {
        return;
      }

      context.root.$store.dispatch("showOverlay");
      state.errors = [];

      await http.post(`/api/teacher/teacher_list/update_user_column`, {user: state.modalUser, column_name: column_name}).then(response => {
        alert(`処理が完了しました。`);
        modalRef.hide();
        search();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 成績閲覧マスタ検索
     ******************************/

    const userResultViewableRangeModalShown = async () => {
      if(state.modalUser.user_result_viewable_ranges != null){
        return;
      }

      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.errors = [];
      await http.get(`/api/teacher/teacher_list/search_user_result_viewable_range?login_id=${state.modalUser.login_id}`).then(response => {
        state.modalUser.user_result_viewable_ranges = response.data.user_result_viewable_ranges.map((x: any) => new UserResultViewableRange(x)); 
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 成績閲覧マスタ追加
     ******************************/

    const addUserResultViewableRange = () => {
      state.modalUser.user_result_viewable_ranges.push(new UserResultViewableRange());
    }

    /******************************
     * 成績閲覧マスタ更新
     ******************************/

    const updateUserResultViewableRange = async () => {
      
      const jsonArray = state.modalUser.user_result_viewable_ranges.map(x => JSON.stringify(x));
      const distinctArray = [...(new Set(jsonArray))];
      if(jsonArray.length != distinctArray.length){
        alert("同一コース・キャンパス・クラスのレコードは複数登録できません。");
        return;
      }

      if (!confirm("成績閲覧範囲を保存します。よろしいですか？")) {
        return;
      }

      context.root.$store.dispatch("showOverlay");
      state.errors = [];

      await http.post(`/api/teacher/teacher_list/update_user_result_viewable_range`, {login_id: state.modalUser.login_id, user_result_viewable_ranges: state.modalUser.user_result_viewable_ranges}).then(response => {
        alert(`処理が完了しました。`);
        userResultViewableRangeModalRef.value.hide();
        search();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * Excelダウンロード
     ******************************/

    const download = async () => {

      context.root.$store.dispatch("showOverlay", "ダウンロード中... しばらくお待ちください。");

      await http.get(`/api/teacher/teacher_list/download?${Common.BuildQuery(state.condition, 'search_condition')}`, {responseType: 'arraybuffer'}).then(async response => {
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `教師マスタ.xlsx`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
          alert(`エクセルのダウンロードに失敗しました。\n${errorData.errors[0]}`);
        }else{
          alert("エクセルのダウンロードに失敗しました。");
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 全件チェックボックス系のwatch
     ******************************/

    watch(() => state.isAllCheckedScoringAuth, (newVal) => {
      state.users.forEach(x => x.scoring_auth = newVal);
    });

    watch(() => state.isAllCheckedResultOutputAuth, (newVal) => {
      state.users.forEach(x => x.result_output_auth = newVal);
    });

    watch(() => state.isAllCheckedBaseSheetEditAuth, (newVal) => {
      state.users.forEach(x => x.base_sheet_edit_auth = newVal);
    });

    watch(() => state.isAllCheckedTouanUploadAuth, (newVal) => {
      state.users.forEach(x => x.touan_upload_auth = newVal);
    });

    watch(() => state.isAllCheckedSubmittedAtEditAuth, (newVal) => {
      state.users.forEach(x => x.submitted_at_edit_auth = newVal);
    });

    watch(() => state.isAllCheckedIsActive, (newVal) => {
      state.users.forEach(x => x.is_active = newVal);
    });

    watch(() => state.isAllCheckedPassword, (newVal) => {
      state.users.forEach(x => x.is_password_checked = newVal);
    });

    watch(() => state.isAllCheckedDelete, (newVal) => {
      state.users.forEach(x => x.is_delete_checked = newVal);
    });

    watch(() => state.isAllCheckedCourse, (newVal) => {
      state.modalUser.scorable_course_codes = newVal ? context.root.$store.state.courses.map((x: any) => x.course_code) : [];
    });

    watch(() => state.isAllCheckedCampus, (newVal) => {
      state.modalUser.scorable_campus_codes = newVal ? context.root.$store.state.campuses.map((x: any) => x.campus_code) : [];
    });

    watch(() => state.isAllCheckedClassification, (newVal) => {
      state.modalUser.scorable_class_codes = newVal ? context.root.$store.state.classifications.map((x: any) => x.class_code) : [];
    });

    watch(() => state.isAllCheckedSubject, (newVal) => {
      state.modalUser.scorable_subject_codes = newVal ? context.root.$store.state.subjects.map((x: any) => x.subject_code) : [];
    });

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      await search();
    });

    return {
      ...toRefs(state),
      userNameModalRef,
      roleModalRef,
      scorableModalRef,
      userResultViewableRangeModalRef,
      search,
      clearCondition,
      updateScoringAuth,
      updateResultOutputAuth,
      updateBaseSheetEditAuth,
      updateTouanUploadAuth,
      updateSubmittedAtEditAuth,
      updateIsActive,
      resetPassword,
      deleteUser,
      showModal,
      updateUserColumn,
      userResultViewableRangeModalShown,
      addUserResultViewableRange,
      updateUserResultViewableRange,
      download,
    };
  },
})
